import {
    GET_CURRENT_SOLUTION
} from './constants';

const initialState = {
    singleSolution: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_SOLUTION: {
            return {
                ...state,
                singleSolution: action.payload,
            };
        }
        default:
            return state;
    }
};

